// LIBRARY
import React from "react";
import CityTable from'./table';
class CityList extends React.Component { 
	render(){

		return (
			<div>
				<CityTable/>
			</div>
		);
	}
}


export default CityList;
	